import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { PatientsService } from '../../../../core/services/patient/patients.service';
import { ToastService } from '../../../../core/services/toast.service';
import { ConsultationsService } from '../../../../core/services/consultation/consultations.service';
import { UsersService } from '../../../../core/services/user/users.service';
@Component({
  selector: 'app-delete-modal',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './delete-modal.component.html',
  styleUrl: './delete-modal.component.scss',
})
export class DeleteModalComponent {
  @Input() data: any[] = [];
  @Input() deleteModalId: string = '';
  @Input() listName: string = '';
  @Output() deleteEvent = new EventEmitter<void>();

  constructor(
    private translate: TranslateService,
    private patientsService: PatientsService,
    private consultationsService: ConsultationsService,
    private usersService: UsersService,
    private toastService: ToastService
  ) {}

  getModalTitle(): string {
    if (this.listName === 'user-list') {
      return this.translate.instant('deleteUser');
    } else if (this.listName === 'consultation-list') {
      return this.translate.instant('deleteConsultation');
    } else if (this.listName === 'referral-list') {
      return this.translate.instant('deleteReferral');
    } else if (this.listName === 'appointment-list') {
      return this.translate.instant('deleteAppointment');
    } else {
      return this.translate.instant('deletePatient');
    }
  }

  getModalMessage(): string {
    if (this.listName === 'user-list') {
      return this.translate.instant(
        'thisActionCannotBeUndoneAreYouSureYouWantToDeleteThisUser'
      );
    } else if (this.listName === 'consultation-list') {
      return this.translate.instant(
        'thisActionCannotBeUndoneAreYouSureYouWantToDeleteThisConsultation'
      );
    } else if (this.listName === 'referral-list') {
      return this.translate.instant(
        'thisActionCannotBeUndoneAreYouSureYouWantToDeleteThisReferral'
      );
    } else if (this.listName === 'appointment-list') {
      return this.translate.instant(
        'thisActionCannotBeUndoneAreYouSureYouWantToDeleteThisAppointment'
      );
    } else {
      return this.translate.instant(
        'thisActionCannotBeUndoneAreYouSureYouWantToDeleteThisPatient'
      );
    }
  }

  deleteItem(id: string) {
    let row: any;
    if (this.listName === 'patient-list') {
      row = this.data.find((item) => item.patientId === id);
      this.deleteListItem(row.patientId);
    } else if (this.listName === 'consultation-list') {
      row = this.data.find((item) => item.patientRecordId === id);
      this.deleteListItem(row.patientRecordId);
    } else if (this.listName === 'referral-list') {
      row = this.data.find((item) => item.patientRecordId === id);
      this.deleteListItem(row.patientRecordId);
    } else if (this.listName === 'appointment-list') {
      row = this.data.find((item) => item.id === id);
      this.deleteListItem(row.id);
    } else if (this.listName === 'user-list') {
      row = this.data.find((item) => item.id === id);
      this.deleteListItem(row.id);
    }
  }

  deleteListItem(id: string): void {
    if (this.listName === 'patient-list') {
      this.patientsService.deletePatient(id).subscribe({
        next: () => {
          this.toastService.showToast(
            this.translate.instant('successDeletePatientDesc'),
            'success'
          );
          this.deleteEvent.emit();
        },
      });
    } else if (this.listName === 'consultation-list') {
      this.consultationsService.deleteConsultation(id).subscribe({
        next: () => {
          this.toastService.showToast(
            this.translate.instant('successDeleteConsultationDesc'),
            'success'
          );
          this.deleteEvent.emit();
        },
      });
    } else if (this.listName === 'referral-list') {
      this.patientsService.deleteReferralPatient(id).subscribe({
        next: () => {
          this.toastService.showToast(
            this.translate.instant('successDeleteReferralDesc'),
            'success'
          );
          this.deleteEvent.emit();
        },
      });
    } else if (this.listName === 'appointment-list') {
      this.patientsService.deleteAppointmentCase(id).subscribe({
        next: () => {
          this.toastService.showToast(
            this.translate.instant('successDeleteAppointmentDesc'),
            'success'
          );
          this.deleteEvent.emit();
        },
      });
    } else if (this.listName === 'user-list') {
      this.usersService.deleteUser(id).subscribe({
        next: () => {
          this.toastService.showToast(
            this.translate.instant('successDeleteUserDesc'),
            'success'
          );
          this.deleteEvent.emit();
        },
      });
    }
  }
}
